<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" sticky="true" style="background-color: #5662eb; box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);" class="navbar" :class="{ 'navbar--hidden': !showNavbar }">
      <router-link class="nav-link" to="intro"><img src="./assets/OAWLogo1.png" width="158" height="30" class="d-inline-block align-top" alt=""></router-link>
      <!-- <b-navbar-brand href="#">OA</b-navbar-brand> -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav style="background-color:#5662eb">
        <b-navbar-nav>
          <b-nav-item>
            <router-link class="nav-link" to="intro">簡介</router-link>
          </b-nav-item>
          <b-nav-item>
            <b-nav-item-dropdown id="nav7_ddown" left>
              <template slot="button-content">OA倡議 </template>
              <b-dropdown-item>
                <router-link to="initiative-brief">開放取用簡介</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="initiative-support">我們支持開放取用</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="initiative-librarian">館員能如何提倡開放取用</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="initiative-teacher">教師能如何提倡開放取用</router-link>
              </b-dropdown-item>
              <b-dropdown-item>
                <router-link to="initiative-research">研究經費獎補助機構<br>&nbsp;&nbsp;可以如何提倡開放取用</router-link>
              </b-dropdown-item>

            </b-nav-item-dropdown>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="postit">活動百寶箱</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="links">相關網站</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="activities">各校OA活動</router-link>
          </b-nav-item>
          <b-nav-item>
            <router-link class="nav-link" to="resources">資源下載</router-link>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          
            <b-nav-item class="nav-link" href="https://forms.gle/hojFdaGe8uDoULQB7">活動登錄
          </b-nav-item>
          <b-nav-item>
            <!-- <router-link class="nav-link" to="/login">登入</router-link> -->

          </b-nav-item>
          <!-- <b-nav-item>
            <router-link class="nav-link" to="#">登入</router-link>
          </b-nav-item> -->

        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
    <img src="./assets/2021-OAW-01-986x310.png" class="img-fluid" alt="Responsive Image" width="100%" style="box-shadow: 0 5px 5px -2px rgba(0,0,0,.5);"/>
    <!-- <router-view class="introduction"></router-view> -->
    <router-view :key="$route.path" />
  </div>
</template>
<script>
  import firebase from 'firebase'
  import Introduction from './components/Introduction.vue';
export default {
  name: 'App',

  data() {
    return {
      showNavbar: true,
      lastScrollPosition: 0
    }
    },
    mounted() {
      window.addEventListener('scroll', this.onScroll)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
      onScroll() {
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
        if (currentScrollPosition < 0) {
          return
        }
        // Stop executing this function if the difference between
        // current scroll position and last scroll position is less than some offset
        if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
          return
        }
        this.showNavbar = currentScrollPosition < this.lastScrollPosition
        this.lastScrollPosition = currentScrollPosition
      }

  }
}

</script>
<style>
#app {
  /*backgroud-image: url(./assets/2019-Open-Access-Week-BLANK-986x310.png);*/
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.navbar {
  height: 60px;
  width: 100vw;
  background: hsl(200, 50%, 50%);
  position: fixed;
  box-shadow: 0 2px 15px rgba(71, 120, 120, 0.5);
  transform: translate3d(0, 0, 0);
  transition: 0.05s all ease-out;
}

.navbar.navbar--hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.container {
  position: relative;
  width: 100%;
  margin-left: -15px;
}

/* Make the image responsive */
.container img {
  margin-top: 20px;
  max-width: 100%;
  height: auto;
}

/* Style the button and place it in the middle of the container/image */
.container .btn {
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 50%;*/
  position: relative;
  transform: translate(150%, -200%);
  -ms-transform: translate(150%, -200%);
  background-color: #555;
  color: white;
  /*font-size: 18px;*/
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.container .btn:hover {
  background-color: black;
}

.navbar-collapse {
  background: #0089b8;
  /*width: 120%;
   margin-top: 23px;
  padding: 9px 10px !important;*/
}

</style>
